export default __webpack_public_path__ + "static/media/dummymarksheet.99605282dad29a883fbd997724fa1f30.png";